import ReactGA from "react-ga4";

export const trackEvent = (name, data, id) => {
    // umami?.track(name);
    // ReactGA.event(
    //     {
    //         category: 'hyper3d',
    //         action: name,
    //         label: 'pressure_tracking'
    //     }
    // )
    console.log(name, data, id);
};